/** Master Admin direct-access rules — bypass portal key gate when configured. */

export function hasMasterTestingKeyConfigured(): boolean {
  const viteKey = (import.meta.env.VITE_MASTER_TESTING_KEY as string | undefined)?.trim();
  return Boolean(viteKey);
}

export function isLocalDevelopmentEnvironment(): boolean {
  if (import.meta.env.DEV) return true;
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

/** True when `/master-admin` may load without prior portal key verification. */
export function isMasterAdminDirectAccessAllowed(): boolean {
  return isLocalDevelopmentEnvironment() || hasMasterTestingKeyConfigured();
}

export function isMaintenancePreviewEmbed(): boolean {
  if (typeof document === 'undefined') return false;
  return Boolean(document.querySelector('.master-admin-screen-mount.maintenance-embed-preview'));
}

/** Scoped to the preview mount only — do not mutate document root (breaks MPL-11 layout). */
export function activateMaintenancePreviewEmbed(): void {
  /* mount div carries maintenance-embed-preview */
}

export function deactivateMaintenancePreviewEmbed(): void {
  /* mount unmount clears preview */
}
